import CheckboxFilledIcon from './CheckboxFilledIcon';

const CheckboxIndeterminateIcon = () => {
  return (
    <CheckboxFilledIcon>
      <rect x="5" y="9" width="10" height="2" rx="1" />
    </CheckboxFilledIcon>
  );
};

export default CheckboxIndeterminateIcon;
